import { ApiProvider, JunctionProvider } from 'providers/request'
import {
  CustomLayer,
  CustomLayerCreateParams,
  CustomLayerUpdateParams,
  CustomLayerStyle,
} from 'models/custom-layer'
import { objectToFormData } from 'utils/object-to-formdata'

export const CustomLayerRepository = {
  fetchAll(): Promise<CustomLayer[]> {
    return ApiProvider.get('/custom_layers')
  },

  fetch(layerId: string): Promise<CustomLayer> {
    return ApiProvider.get(`/custom_layers/${layerId}`)
  },

  create(data: CustomLayerCreateParams): Promise<CustomLayer> {
    const formData = objectToFormData(data)
    return ApiProvider.post('/custom_layers', formData)
  },

  createNew(data: CustomLayerCreateParams): Promise<CustomLayer> {
    const formData = objectToFormData(data)
    return JunctionProvider.post('/custom_layers', formData)
  },

  update(
    id: string,
    data: CustomLayerUpdateParams | { viz: CustomLayerStyle },
  ): Promise<CustomLayer> {
    const formData = objectToFormData(data)
    return ApiProvider.patch(`/custom_layers/${id}`, formData)
  },

  updateLayer(
    id: string,
    data: CustomLayerUpdateParams | { viz: CustomLayerStyle },
  ): Promise<CustomLayer> {
    const formData = objectToFormData(data)
    return JunctionProvider.patch(`/custom_layers/${id}`, formData)
  },

  delete(id: string): Promise<any> {
    return ApiProvider.delete(`/custom_layers/${id}`)
  },
}
